import React, { useContext } from 'react';
import { jsPDF } from "jspdf";
import 'jspdf-autotable';
import { useHistory } from "react-router-dom";


import Header from '../../layout/Header';
import Consumo from '../consumos/Consumo';
import Totalizador from '../consumos/Totalizador';
import consumoContext from '../../../context/consumos/consumoContext';
import proyectoContext from '../../../context/proyectos/proyectoContext';


const Consumos = () => {

    // extraer el estado de consumos
    const consumosContext = useContext(consumoContext);
    const { consumosproyecto } = consumosContext;
    
    // extraer si un proyecto esta activo
    const proyectosContext = useContext(proyectoContext);
    const { proyecto } = proyectosContext;
    
    // Array destructuring para extraer el proy actual
    const [proyectoActual] = proyecto;

    const history = useHistory();

    // Crear PDF Tabla 1 y Tabla 2
    const printPDF = () => {
        
        // Create a new jsPDF instance
        const doc = new jsPDF("p", "pt", "a4"); // default values
        // set font
        doc.setFont("helvetica", "bold");

        // font size
        doc.setFontSize(20);

        // title, centered around x
        // doc.text(text, x, y, flags, angle, align);
        doc.text(
        `Consumos Eléctricos Proyecto ${proyectoActual.nombre}`,
        105 * 2.83,
        20 * 2.83,
        null,
        null,
        "center"
        );

        // Table 1
        const consumosCol = ["Nombre Electrodoméstico", "Potencia en Watts", "Tiempo de uso diario en horas", "Consumo en Watts-hora"];

        const consumosRows = consumosproyecto.map(consumo => {
            const row = [consumo.nombre, consumo.potencia, consumo.uso, consumo.consumoE];
            return row;
        });

        // const startY = 10 * 2.83;
        const startY = 30 * 2.83;
        doc.autoTable(consumosCol, consumosRows, {
            // startY: 180 * 2.83,
            startY,
            theme: "striped",
            styles: {
            fontSize: 11
            },
            headStyles: {
                fillColor: [56, 41, 51],
                fontSize: 11,
            },
        });

        // codigo para pdf de la Tabla 2
        let totalConsumo = 0;
        consumosproyecto.forEach(function(elemento, indice){
        totalConsumo += elemento['consumoE'];
        });

        //console.log(totalConsumo);
        const consumoSem = (totalConsumo*7/1000).toFixed(2);
        const consumoMes = (totalConsumo*30/1000).toFixed(2);
        const consumoAnio = (consumoMes*12).toFixed(2);

        
        //const start2Y = 80 * 2.83;

        doc.autoTable({

            head: [["Consumo Diario", "Consumo Semanal", "Consumo Mensual", "Consumo Anual"]],

            body: [[totalConsumo +" Wh", consumoSem +" kWh", consumoMes +" kWh", consumoAnio +" kWh"]],
            foot: [["Suma de consumos diarios", "(Consumo Diario X 7)/1000", "(Consumo Diario X 30)/1000", "Consumo Mensual X 12"]],

            headStyles: {
                fillColor: [59, 82, 73],
                fontSize: 11,
            },
            footStyles: {
                fillColor: [164, 180, 148],
                fontSize: 9,
                textColor: 68,
            },
            
            theme: "grid",
            styles: {
            fontSize: 11
            }
        });
        

        
        doc.setFontSize(7);
        doc.text(
            `ELECTRONATURAL ©${new Date().getFullYear()} All rights reserved`,
            142 * 2.83,

            doc.autoTable.previous.finalY + 22
        );

        doc.save(`Proyecto_${proyectoActual.nombre}_${new Date().toISOString()}.pdf`);        
    
    };

    const agregarConsumo = () => {
        history.push(`/proyectos/consumos/nuevo`);
    }
        
        

    return (  
        <><div>
        <Header />
            <h2 className="mt-3">Tabla para Calcular Consumos Eléctricos</h2>
            <h2>Proyecto: {proyectoActual.nombre}</h2>
            <table className="table table-hover ">
                <thead className="bg-primary table-dark">
                    <tr className="centrartxt">
                        <th scope="col">Nombre Electrodoméstico</th>
                        <th scope="col">Potencia en Watts</th>
                        <th scope="col">Tiempo de uso en horas</th>
                        <th scope="col">Consumo en Watts-hora</th>
                        <th>
                            <button 
                                type="button" 
                                className="btn btn-outline-success"   
                                onClick={ () => agregarConsumo()}
                            >Agregar Consumo &#43;
                            </button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    { consumosproyecto.length > 0 ?  (
                        consumosproyecto.map( consumo =>(
                            <Consumo
                                key={consumo._id}
                                consumo={consumo}
                            />
                        ))
                    )
                    : (<tr><td>No hay Consumos</td></tr>)}
                </tbody>   
            </table>
            <div >
                <Totalizador 
                    consumosproyecto={consumosproyecto}
                />
            </div>
                <h6 className="enaturalDR">ELECTRONATURAL ©{new Date().getFullYear()} All rights reserved</h6>
            </div>
            <button
                type="button"
                id="notpdf"
                className="btn btn-warning"
                onClick={printPDF}
            >Descargar esta Información en PDF</button>
        </>
    );
}
 
export default Consumos;